import { defineStore } from 'pinia';
import { computed } from 'vue';

import { useLocalStorage, watchImmediate } from '@vueuse/core';

import { useNewVersionTimestampQuery } from '../queries';

const useNewAppVersionStore = defineStore('newAppVersion', () => {
  const timestampStorage = useLocalStorage('last-update', '', { writeDefaults: false });

  const { data: timestamp } = useNewVersionTimestampQuery();

  const isNewVersionAvailable = computed<boolean>(() => !!timestamp.value && !!timestampStorage.value && (timestamp.value !== timestampStorage.value));

  watchImmediate(timestamp, (newTimestamp) => {
    if (newTimestamp && !timestampStorage.value) {
      timestampStorage.value = newTimestamp;
    }
  });

  function update(): void {
    timestampStorage.value = timestamp.value;
    window.location.reload();
  }

  return {
    isNewVersionAvailable,
    update,
  };
});

export default useNewAppVersionStore;
